import React from "react";
import PropTypes from "prop-types";
import { Button } from "../../primary";
import shared from "../../../styles/common.module.scss";
import styles from "./FormActions.module.scss";

/**
 * FormActions — a primary/secondary action-button pair (Save/Cancel, Yes/No, Enable/Disable...)\
 *  - `secondaryVariant="secondary"` (default): the grey outline used for form Cancel actions.
 *  - `secondaryVariant="outline"`: the brand-blue outline used for Yes/No confirm modals.
 */
export const FormActions = ({
  align = "center",
  className,
  primaryLabel,
  primaryId,
  primaryTestId,
  primaryType = "button",
  primaryDisabled,
  primaryLoading,
  onPrimaryClick,
  secondaryLabel,
  secondaryId,
  secondaryTestId,
  secondaryType = "button",
  secondaryDisabled,
  secondaryVariant = "secondary",
  onSecondaryClick,
}) => (
  <div className={`${styles.actions} ${align === "end" ? styles.actions_end : ""} ${className || ""}`}>
    <Button
      type={primaryType}
      id={primaryId}
      data-testid={primaryTestId || primaryId}
      classes={{ className: `${styles.btn_primary_action} ${shared.d_flex}` }}
      onClick={onPrimaryClick}
      disabled={primaryDisabled || primaryLoading}
    >
      {primaryLoading && <span className={shared.custom_spinner} />}
      {primaryLabel}
    </Button>
    <Button
      type={secondaryType}
      id={secondaryId}
      data-testid={secondaryTestId || secondaryId}
      classes={{ className: secondaryVariant === "outline" ? styles.btn_outline_action : styles.btn_secondary_action }}
      onClick={onSecondaryClick}
      disabled={secondaryDisabled}
    >
      {secondaryLabel}
    </Button>
  </div>
);

FormActions.propTypes = {
  align: PropTypes.oneOf(["center", "end"]),
  className: PropTypes.string,
  primaryLabel: PropTypes.node.isRequired,
  primaryId: PropTypes.string,
  primaryTestId: PropTypes.string,
  primaryType: PropTypes.oneOf(["button", "submit"]),
  primaryDisabled: PropTypes.bool,
  primaryLoading: PropTypes.bool,
  onPrimaryClick: PropTypes.func,
  secondaryLabel: PropTypes.node.isRequired,
  secondaryId: PropTypes.string,
  secondaryTestId: PropTypes.string,
  secondaryType: PropTypes.oneOf(["button", "submit"]),
  secondaryDisabled: PropTypes.bool,
  secondaryVariant: PropTypes.oneOf(["secondary", "outline"]),
  onSecondaryClick: PropTypes.func,
};
